<script setup>
  import { storeToRefs } from "pinia";
  import { Switch } from "@/components/ui/switch";
  import ListContainer from "@/components/episto-ui/list/ListContainer.vue";
  import ListItem from "@/components/episto-ui/list/ListItem.vue";
  import { usePricerProjectStore } from "@stores/pricer/pricerProject";
  import { getFlagByCountryCode } from "@utils/constants/regions";
  import { calculateCountryTotalDisplay } from "@utils/pricer/pricerHelpers";

  const projectStore = usePricerProjectStore();
  const { project, selectedTargetToken } = storeToRefs(projectStore);
  const { addTarget, removeTarget, duplicateTarget, selectTarget } = projectStore;

  const isTargetSelected = (index) => {
    const target = project.value.targets[index];
    return target && target.token === selectedTargetToken.value;
  };

  const updateTargetStatus = (index, isActive) => {
    project.value.targets[index].active = isActive;
  };
</script>

<template>
  <ListContainer
    :add-element="addTarget"
    element-name="target"
    :show-header="false">
    <template #elements>
      <ListItem
        v-for="(target, index) in project.targets"
        :key="target.token"
        :index="index"
        :element-title="target.name"
        :select-element="() => selectTarget(target.token)"
        :duplicate-element="duplicateTarget"
        :delete-element="removeTarget"
        :confirm-deletion="true"
        :is-element-selected="isTargetSelected">
        <template #actions>
          <Switch
            size="sm"
            :model-value="target.active"
            @update:model-value="updateTargetStatus(index, $event)" />
        </template>
        <template #additional-content>
          <div class="flex flex-col gap-0.5">
            <div
              v-for="country in target.countries"
              :key="country.country"
              class="text-2xs text-foreground-subtle">
              {{ getFlagByCountryCode(country.country) }} CPI {{ country.cpi_manual || country.cpi_auto || 0 }}€ -
              {{ calculateCountryTotalDisplay(country) }}€
            </div>
          </div>
        </template>
      </ListItem>
    </template>
  </ListContainer>
</template>
